import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a702c522"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "link" }

import { watch, ref, unref, onMounted, onBeforeUnmount } from 'vue';
import { LinkContent } from '../type';
import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import { init, apikey } from '@/components/CTinymce';

interface IProps {
  modelValue: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Link',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: any;
};


const form = ref<LinkContent>({
  content_url: '',
  content: '',
});
form.value = unref(props.modelValue);


watch(form, (newVal) => {
  emit('update:modelValue', newVal);
});

onMounted(() => {
  tinymce.init({});
});
onBeforeUnmount(() => {
  tinymce.remove();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Editor), {
        modelValue: form.value.content,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.content) = $event)),
        "api-key": _unref(apikey),
        init: _unref(init)
      }, null, 8, ["modelValue", "api-key", "init"])
    ]),
    _createVNode(_component_a_input, {
      class: "link_input",
      size: "large",
      value: form.value.content_url,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.content_url) = $event))
    }, null, 8, ["value"])
  ], 64))
}
}

})